// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"633":"d18a9d54","795":"1f0c0709"}[chunkId] + ".chunk.js";
};